import { render, staticRenderFns } from "./AccountBookOverview.vue?vue&type=template&id=6c0b7f02&scoped=true&"
import script from "./AccountBookOverview.vue?vue&type=script&lang=js&"
export * from "./AccountBookOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b7f02",
  null
  
)

export default component.exports